<template>
  <div class="flex flex-col relative notification-wrap" @click="click">

    <div class="vertical item-center justify-center" :style="{height:itemHeight}">
      <van-image :src="device.flavorPicture" fit="contain" show-loading :height="height">
        <template v-slot:loading>
          <van-loading type="spinner" size="50"/>
        </template>
      </van-image>
      <span style="color:#757575;font-size:14px;height:14px" >{{ device.flavorName }}</span>
    </div>

    <div class="pt-2.5 pb-2.5 pl-3 pr-3" style="background: #f6f6f6;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px">
      <div class="vertical ">
        <span class="title text-left text-14px">{{ device.deviceName }}</span>
        <span class="third-color text-left text-12px">{{ device.tag }}</span>
      </div>
      <div class="flex flex-row items-center justify-between mt-4 " style="font-size:12px;">
        <span class="main-color">{{ device.brandName }}</span>
        <span class="third-color">{{ device.createTime }}</span>
      </div>
    </div>
    <div class="favorite-icon" @click="onFavoriteClick">
      <van-image  v-if="device.isFavorite === 1"  :src="require('@/assets/icons/consumer/mydevices/ic_unlike.svg')" />
      <van-image  v-else  :src="require('@/assets/icons/consumer/mydevices/ic_like.svg')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FavoriteDeviceItem",
  props: {
    device: {
      type: Object,
      required: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    height: {
      type:Number,
      default: 170
    }
  },
  data() {
    return {
      itemWidth: 0
    };
  },
  methods: {
    click() {
      this.$emit("click");
    },
    onFavoriteClick() {
      this.$emit("onFavoriteClick");
    }
  },
  computed: {
    itemHeight() {
      return `${this.height + 14 + 16}px`
    }
  },
  mounted() {
    this.itemWidth = `${(document.body.clientWidth - 48) / 2}px`;
    console.log(`item width = ${this.itemWidth}`);
  }
};
</script>

<style scoped lang="less">
.notification-wrap {
  border-radius: 12px;
  background: white;
}

::v-deep .van-image {
  img {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px
  }
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
  font-size: 14px;
  text-align: start;
}

.favorite-icon {
  position: absolute;
  right: 15px;
  top: 10px;
  ::v-deep .van-image {
    img {
      border-top-left-radius: 0;
      border-top-right-radius: 0
    }
  }
}

</style>